const ITEMS = [
  "TOKYO — TORONTO", "通訳 · INTERPRETATION", "文化 · CULTURE", "改善 · KAIZEN",
  "教育 · EDUCATION", "信頼 · TRUST", "架け橋 · KAKEHASHI",
];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 select-none ${
        dark ? "border-navy-border bg-navy" : "border-sand bg-cream"
      }`}
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-serif text-xl sm:text-2xl italic tracking-wide ${
                  dark ? "text-[#B7C6E2]" : "text-navy"
                }`}>
                  {item}
                </span>
                <span className={`mx-8 text-sm ${dark ? "text-coral-light" : "text-coral"}`}>✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
